import { render, staticRenderFns } from "./EventPaymentSystem.vue?vue&type=template&id=6346363f&scoped=true"
import script from "./EventPaymentSystem.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventPaymentSystem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventPaymentSystem.vue?vue&type=style&index=0&id=6346363f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346363f",
  null
  
)

export default component.exports